import BladeContainer from './BladeGatsbyCDAContainer'
import BladeApolloCPAContainer from './BladeApolloCPAContainer'
export default BladeContainer
export { BladeContainer as BladeGatsbyCDAContainer, BladeApolloCPAContainer }
